import React from 'react';
import { useTranslation } from 'react-i18next';
import { getActiveWardStudentId, setActiveWardStudentId } from '../utils/wardContext';

export default function WardSwitcher({ wards = [], selfStudentId, schoolId, onChange }) {
    const { t } = useTranslation(['wardSwitcher', 'common']);

    if (!wards?.length) return null;

    const schoolWards = schoolId
        ? wards.filter((w) => w.schoolId === schoolId)
        : wards;

    if (schoolWards.length === 0) return null;

    const active = getActiveWardStudentId();
    const current = schoolWards.some((w) => w.studentId === active)
        ? active
        : schoolWards[0].studentId;

    if (active !== current) setActiveWardStudentId(current);

    return (
        <div style={{
            marginBottom: '16px', padding: '12px 14px', background: '#f0ebff',
            borderRadius: '12px', border: '1px solid #ddd6fe'
        }}>
            <div style={{ fontSize: '12px', fontWeight: 700, color: '#5b21b6', marginBottom: '8px' }}>
                {t('wardSwitcher:title')}
            </div>
            <select
                value={current}
                onChange={(e) => {
                    const id = Number(e.target.value);
                    setActiveWardStudentId(id);
                    onChange?.(id);
                }}
                style={{
                    width: '100%', padding: '10px 12px', borderRadius: '8px',
                    border: '1px solid #c4b5fd', fontSize: '14px', background: '#fff'
                }}
            >
                {selfStudentId && (
                    <option value={selfStudentId}>{t('wardSwitcher:selfOption')}</option>
                )}
                {schoolWards.map((w) => (
                    <option key={w.studentId} value={w.studentId}>
                        {w.studentFullName} ({w.schoolName})
                    </option>
                ))}
            </select>
        </div>
    );
}
